import { PASS_RATE_AT_RISK, PASS_RATE_HEALTHY } from "../adminReportUtils";

const toneFor = (passRate: number) => {
  if (passRate >= PASS_RATE_HEALTHY) return "healthy";
  if (passRate >= PASS_RATE_AT_RISK) return "at-risk";
  return "failing";
};

/** passRate is null for a region that has never recorded a run. */
const PassRateMeter = ({ passRate }: { passRate: number | null }) => {
  if (passRate === null) {
    return <span className="admin-report__doc-sub">Not run</span>;
  }

  const tone = toneFor(passRate);

  return (
    <div className="admin-report__meter-cell">
      <div
        className="admin-report__meter"
        role="progressbar"
        aria-valuenow={passRate}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Pass rate ${passRate}%`}
      >
        <div
          className={`admin-report__meter-fill admin-report__meter-fill--${tone}`}
          style={{ width: `${passRate}%` }}
        />
      </div>
      <span
        className={`admin-report__meter-value admin-report--${tone}`}
      >{`${passRate}%`}</span>
    </div>
  );
};

export default PassRateMeter;
